const $ = jQuery.noConflict();

class Search {
    constructor() {
        this.header = $('.main-header');
        this.searchTrigger = this.header.find('.main-header__search-trigger');
        this.search = this.header.find('.search-hero');
        this.searchParent = this.search.parent();

        this.searchForm = $('.search-form');
        this.searchInput = this.searchForm.find('input[type="search"]');
    }

    init() {
        this.searchInput.on('input', this.typingInput);
        this.searchTrigger.on('click', this.toggleSearch.bind(this));

        this.searchInput.on( "focusin", function() {
            $(this).parent().addClass('focused');
        });

        this.searchInput.on( "focusout", function() {
            $(this).parent().removeClass('focused');
        });

        if (this.search.hasClass('no-focus')) {
            this.search.find('input, button').attr('tabindex', '-1');
            this.search.removeClass('no-focus');
        }
    }

    typingInput(e) {
        const form = $(this).parent();

        if (this.value !== '') {
            form.addClass('filled');
        } else {
            form.removeClass('filled');
        }
    }

    toggleSearch() {
        if (this.searchParent.hasClass('active')) {
            this.closeSearch();
        } else {
            this.openSearch();
        }
    }

    openSearch() {
        this.setSearchHeight();
        this.searchParent.addClass('active').find('input[type="search"]').focus();
        this.search.find('input, button').removeAttr('tabindex');
    }

    closeSearch() {
        this.searchParent.removeClass('active').find('input[type="search"]').blur();
        this.search.find('input, button').attr('tabindex', '-1');
    }

    setSearchHeight() {
        const height = window.innerHeight - this.header.outerHeight();

        this.searchParent.css('height', height);
    }

    resized() {
        this.setSearchHeight();
    }

    hideOutsideClick(e) {
        if (this.searchParent.hasClass('active') && !this.search.is(e.target) && this.search.has(e.target).length === 0 && !this.searchTrigger.is(e.target)) {
            this.closeSearch();
        }
    }

    keyDown(e) {
        if (e.keyCode === 27 && this.searchParent.hasClass('active')) {
            this.closeSearch();
        }
    }
}

export default new Search();
